import { Dispatch, SetStateAction, useState } from 'react';
import * as yup from 'yup';
import { DoctorBank } from 'types/doctor';

export type DoctorBankValidation = {
  bank_name?: string;
  pix_key?: string;
  pix_key_type?: string;
  bank_account?: string;
  bank_agency?: string;
};

type UseDoctorBankValidation = [
  DoctorBankValidation,
  Dispatch<SetStateAction<DoctorBankValidation>>,
  (bank: DoctorBank) => Promise<void>,
];

export function useDoctorBankValidation(): UseDoctorBankValidation {
  async function handleValidation(bank: DoctorBank) {
    const schema = yup.object().shape({
      pix_key: yup.string().required('A chave PIX é obrigatória'),
      pix_key_type: yup.string().required('O tipo da chave PIX é obrigatório'),
      bank_account: yup.string().required('A conta bancária é obrigatória'),
      bank_agency: yup.string().required('A agência bancária é obrigatória'),
      bank_name: yup.string().required('O nome do banco é obrigatório'),
    });

    try {
      await schema.validate(bank);
    } catch (err) {
      const error = err as yup.ValidationError;
      if (error.path && error.message) {
        setValidation({
          [error.path]: error.message,
        });
      }
      throw new Error(err as string);
    }
  }

  const [validation, setValidation] = useState<DoctorBankValidation>({});
  return [validation, setValidation, handleValidation];
}
